import { render } from "./PageContainer.vue?vue&type=template&id=dcef8b82"
const script = {}

import "./PageContainer.vue?vue&type=style&index=0&id=dcef8b82&lang=css"

import exportComponent from "/builds/filmin/amff-2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__